/**
 * Core shop definitions for Idle Depths.
 *
 * Shops are location-specific. Every location has a general store,
 * with specialized shops in appropriate locations.
 */

import { type ShopDefinition, isShopDefinition, SELL_PRICE_MULTIPLIER } from '@idle-depths/shared';

export { isShopDefinition };

/**
 * Core shop definitions.
 *
 * Currently includes:
 * - General Store (coastal_village)
 */
export const CORE_SHOPS: ShopDefinition[] = [
  {
    id: 'general_store_coastal_village',
    name: 'General Store',
    locationId: 'coastal_village',
    sellPriceMultiplier: SELL_PRICE_MULTIPLIER,
    buybackEnabled: true,
    inventory: [
      // Weapons
      { itemId: 'iron_sword', stockLimit: null },
      { itemId: 'steel_dagger', stockLimit: 5 },
      { itemId: 'oak_bow', stockLimit: null },

      // Armor
      { itemId: 'leather_cap', stockLimit: null },
      { itemId: 'iron_chainmail', stockLimit: 3 },
      { itemId: 'wooden_shield', stockLimit: null },

      // Resources (limited stock - restocks over time)
      { itemId: 'oak_logs', stockLimit: 100 },
      { itemId: 'copper_ore', stockLimit: 50 },

      // Consumables
      { itemId: 'health_potion', stockLimit: 50 },
      { itemId: 'stamina_potion', stockLimit: 30 },
      { itemId: 'bread', stockLimit: null },
    ],
  },
];
